import {FC} from 'react';
import {ModalProps} from 'components/Modal/Modal';
import {useTranslation} from 'react-i18next';
import {LEAVE_STATUS_DELETED, LeaveRequest} from 'models/leaveRequest';
import './LeaveRequestDeleteModal.scss';
import LeaveUpdateStatusModal from 'viewComponents/LeaveUpdateStatusModal/LeaveUpdateStatusModal';

interface LeaveRequestDeleteModalProps
  extends Omit<ModalProps, 'children' | 'title' | 'description'> {
  children?: Children;
  leaveData?: LeaveRequest;
}

const LeaveRequestDeleteModal: FC<LeaveRequestDeleteModalProps> = ({
  leaveData,
  ...other
}) => {
  const {t} = useTranslation();
  const leaveRequestUpdate = {
    id: leaveData?.id || '',
    status: LEAVE_STATUS_DELETED,
  };

  return (
    <LeaveUpdateStatusModal
      leaveRequestId={leaveRequestUpdate.id}
      leaveRequestStatus={leaveRequestUpdate.status}
      title={t('leaves.LeaveRequestDeleteModal.title')}
      description={t('leaves.LeaveRequestDeleteModal.description')}
      {...other}
    />
  );
};

export default LeaveRequestDeleteModal;
